export const actionTypes = {
    SET_MEASUREMENT_DIALOG_PARAMS: 'downloadMeasurements/SET_MEASUREMENT_DIALOG_PARAMS',
    EXPORT_EXCEL_MEASUREMENT: 'downloadMeasurements/EXPORT_EXCEL_MEASURMENT',
    CLEAR_STORE: 'downloadMeasurements/CLEAR_STORE'
};
